export default __webpack_public_path__ + "static/media/wedding-thumbnail-2.26b97113.jpg";